<template>
  <div class="sidebar">
    <a :href="homeHref" target="_blank">
      <div class="sidebar_header">
        <i class="iconfont icontoubide sidebar_header_icon"></i>
        <p class="sidebar_header_text">{{$t('topedit.topedit')}}</p>
      </div>
    </a>
    <div class="sidebar_main">
      <vue-scroll :ops="{ bar: { background: '#66A5D5' } }">
        <el-menu class="my-el-menu-no-border" :router="true" :unique-opened="true" :default-active="$route.meta.sidebar">
          <div v-for="item in sidebar[role]" :key="item.index">
            <template v-if="item.children">
              <el-submenu :index="item.index">
                <template slot="title">
                  <div class="menu_item_title">
                    <i :class="['iconfont', item.icon]"></i>
                    {{$t(`topedit.layout.sidebar.${item.title}`)}}
                  </div>
                </template>
                <el-menu-item :index="subItem.index" v-for="subItem in item.children" :key="subItem.key">
                  <div class="sub_menu_item_title">
                    {{$t(`topedit.layout.sidebar.${subItem.title}`)}}
                  </div>
                </el-menu-item>
              </el-submenu>
            </template>
            <template v-else>
              <el-menu-item :index="item.index" >
                <template slot="title">
                  <div class="menu_item_title">
                    <i :class="['iconfont', item.icon]"></i>
                    {{$t(`topedit.layout.sidebar.${item.title}`)}}
                  </div>
                </template>
              </el-menu-item>
            </template>
          </div>
        </el-menu>
      </vue-scroll>
    </div>
    <div class="sidebar_footer">
      <img src="../../../assets/img/logo_sidebar_bottom.png" />
    </div>
  </div>
</template>

<script>
import {OFFICIAL_WEB_URL} from '~/config'
import sidebar from './sidebar'
export default {
  data () {
    return {
      sidebar: sidebar
    }
  },
  computed: {
    role () {
      return this.$store.state.userInfo.role
    },
    homeHref () {
      return OFFICIAL_WEB_URL
    }
  }
}
</script>

<style lang="scss" scoped>
.sidebar {
  width: 240px;
  height: 100%;
  background:linear-gradient(315deg,rgba(1,130,188,1) 0%,rgba(0,98,184,1) 100%);
  .sidebar_header {
    display: flex;
    height: 80px;
    color: white;
    padding: 20px 0 40px 20px;
    align-items: baseline;
    &_icon {
      font-size: 20px;
    }
    &_text {
      font-size: 12px;
      margin-left: 12px;
    }
  }
  .sidebar_main {
    height: calc(100% - 160px);
    .menu_item_title, .sub_menu_item_title {
      position: relative;
      color: rgba(255, 255, 255, 0.8);
      &::before {
        content: "";
        position: absolute;
        height: 100%;
        left: -20px;
        width: 4px;
        background-color: transparent;
      }
      & > i {
        color: rgba(255, 255, 255, 0.8);
        margin-right: 10px;
      }
    }
    .sub_menu_item_title {
      padding-left: 20px;
      &::before {
        left: -40px;
      }
    }
    .el-menu-item.is-active {
      .menu_item_title, .sub_menu_item_title {
        color: white;
        &::before {
          background-color: white;
        }
        & > i {
          color: white;
        }
      }
    }
  }
  .sidebar_footer {
    height: 80px;
    padding-top: 20px;
    display: flex;
    justify-content: center;
    & > img {
      width: 221px;
      height: 50px;
    }
  }
}
</style>

<style lang="scss">
  .sidebar_main {
    .el-menu {
      .el-submenu {
        .el-submenu__title {
          .el-submenu__icon-arrow {
            color: rgba(255, 255, 255, 0.8);
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/sidebar/index.vue